import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { messageVariableFallbacksClient } from '~/services';
import { normalizeFallbackKey, type MessageVariableFallbackMap } from '~/utils/messageVariableFallbacks';

export const useMessageVariableFallbacks = createGlobalState(() => {
    const fallbacks = ref<MessageVariableFallbackMap>({});
    let pending: Promise<void> | undefined;

    // Every load re-reads the team's set so a fallback saved on Team Profile is picked up, while callers that load
    // together share one request. The map keeps its last value until the new one lands.
    const load = (): Promise<void> => {
        pending ??= messageVariableFallbacksClient
            .getMessageVariableFallbacks(Spark.state.currentTeam.id)
            .then(({ data }) => {
                fallbacks.value = Object.fromEntries(
                    data.data.map((fallback) => [normalizeFallbackKey(fallback.variable_key), fallback.fallback_value])
                );
            })
            .finally(() => {
                pending = undefined;
            });

        return pending;
    };

    return { fallbacks, load };
});
